<div class="toggle-button-field">
  <label class="toggle-button-label" [id]="id + '-label'">
    {{ label }}
    <span *ngIf="required"> *</span>
  </label>
  <button
    type="button"
    class="toggle-button"
    [class.toggle-button-selected]="control.value === true"
    [id]="id"
    [attr.aria-pressed]="control.value === true"
    [attr.aria-labelledby]="id + '-label ' + id"
    [attr.aria-required]="required ? 'true' : null"
    [attr.aria-invalid]="isInvalid"
    [attr.aria-describedby]="isInvalid ? errorId : null"
    (click)="toggle()"
  >
    {{ (control.value ? 'Included' : 'Add') | translate }}
  </button>
  <p [id]="errorId" class="toggle-button-error" *ngIf="isInvalid">
    {{ errorText }}
  </p>
</div>
